<template>
    <!-- custom filter scenario 4 -->
    <!-- location filter -->

    <div class="custom-filter-container pl-20">

        <!-- Custom filter -->
        <el-row gutter="20">
            <el-col class="filter-s4-col"
            :span="$vuetify.display.width > 1000 ? 10 : 24" 
            :class="$vuetify.display.width > 645 ? 'x-start' : ''" 
            :style="$vuetify.display.width > 645 ? 'margin-left: 0px; padding-left: 32px;' : 'margin-left: 0px; padding-left: 32px;'"
            >
 
                <!-- location select -->
                <div>
                    <el-tree-select
                        class="custom-filter-select filter-s4-select"
                        v-model="locationSelection"
                        :data="treeData"
                        :render-after-expand="false"
                        filterable
                        placeholder="Select country or elec region"
                        @change="onTreeLocationChange"
                        clearable
                        >
                        <template #default="{ data }">
                                        <span>{{ data.label.replace("_", " ")}}</span>
                                    </template>
                    </el-tree-select>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { shorterLabel, buildElecRegionTreeData, applyTreeLocationSelection } from "./common-tools";
import UserService from "../../../services/user.service";
export default {
    props: {
        stateProp: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            countries: [],
            elecRegionsByCountry: {},
            loading: false,
            options: [], // for location and MP dropdowns
            list: [], // backup list for filtering
            filter: {
                customer_id: null,
                country: "",
                elec_region: "",
                startDate: null,
                endDate: null,
                groupBy: null,
                groupByItem: null,
                charger_name: null,
            },

            locationSelection: "", // Internal selection state for the dropdown
            treeData: [], // Tree structure for countries and elec regions


            optionName: '',
            isAdding: false,
        }
    },

    async mounted() {
        await this.fetchStates();
        this.applyFilter();
    },

    methods: {
        // change label to shorter label for fixed button length
        shortLabel(inputLabel,length,MaxLength,additional) {
        let label = shorterLabel(inputLabel,length,MaxLength,additional);
        return label;
        },

        async fetchStates() {
            await UserService.ChargerMapGroupGetStates()
                .then(response => {
                    if (response.data && response.data.data) {
                        this.countries = Object.keys(response.data.data);
                        this.elecRegionsByCountry = response.data.data;
                        this.treeData = buildElecRegionTreeData(this.elecRegionsByCountry);
                    }
                });
        },

        onTreeLocationChange(value) {
            const next = applyTreeLocationSelection(value, this.elecRegionsByCountry);
            this.filter.country = next.country;
            this.filter.elec_region = next.elec_region;
            this.locationSelection = next.locationSelection;
            this.applyFilter();
        },


        handleFilterState(event) {
            this.filter.elec_region = event;
        },

        onAddOption() {
            this.isAdding = true
        },

        onConfirm() {
        if (this.optionName) {
            this.monitoringPeriods.push({
            label: this.optionName,
            value: this.optionName,
            })
            this.clear()
        }
        },

        clear() {
            this.optionName = ''
            this.isAdding = false
        },

        applyFilter() {
            this.displayCustomDate = false;
            this.$emit("filterHandle", this.filter);
        },
        // resetFilter() {
        //     this.filter = {
        //         customer_id: null,
        //         country: "",
        //         elec_region: "",
        //         startDate: null,
        //         endDate: null,
        //         groupBy: null,
        //         groupByItem: null,
        //         charger_name: null,
        //     };
        //     this.dateTimeRange = [null, null];
        //     this.$emit("filterHandle", this.filter);
        // },
    },

}
</script>

